import "../../../../FhTableCell.css";
import { openBlock, createBlock, resolveDynamicComponent, normalizeClass, withCtx, createElementVNode, renderSlot } from "vue";
import { ALIGNMENTS_ENUMS } from "../../FhDataTableColumn/constants.mjs";
import { TAGS_ENUMS } from "./constants.mjs";
import { _ as _export_sfc } from "../../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = { class: "fh-table-cell" };
const _sfc_main = {
  __name: "FhTableCell",
  props: {
    tag: {
      type: String,
      default: TAGS_ENUMS.TH,
      validator: (value) => Object.values(TAGS_ENUMS).includes(value)
    },
    align: {
      type: String,
      default: ALIGNMENTS_ENUMS.START,
      validator: (value) => Object.values(ALIGNMENTS_ENUMS).includes(value)
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(props.tag), {
        class: normalizeClass(props.align && `fh-table-cell--${props.align}`)
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ])
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
};
const FhTableCell = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-12eabf47"]]);
export {
  FhTableCell as default
};
//# sourceMappingURL=FhTableCell.mjs.map
